import React, { useState } from 'react';
import { Card, CardBody, Nav } from 'react-bootstrap';


function InfoMenuCard() {
  const [activeLink, setActiveLink] = useState('performance');

  const handleScroll = (section) => {
    try {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveLink(section);
      }
    } catch (err) {
      console.error("Scroll error:", err);
    }
  };

  const navItems = [
    { key: 'performance', label: 'Performance' },
    { key: 'growth-interest', label: 'Growth & Interest' },
    { key: 'audience', label: 'Audience' }
  ];

  return (
    <div className="mt-3 p-2 border rounded-7 bg-light" style={{ borderLeft: 'none', borderRight: 'none', top: '80px' }}>
      <div className="d-flex justify-content-center p-2">
        <div className="nav-pill-wrapper bg-light rounded-pill px-3 py-2 shadow-sm">
          <Nav className="d-flex gap-2">
            {navItems.map((item) => (
              <Nav.Item key={item.key}>
                <Nav.Link
                  onClick={() => handleScroll(item.key)}
                  className={`nav-pill-btn ${activeLink === item.key ? 'active' : ''}`}
                >
                  {item.label}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      </div>
    </div>
  );
}

export default InfoMenuCard;
